import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Form, Text, Incrementor, FormField } from 'src/Components'
import { FormattedMessage } from 'react-intl'

import NavigationButtons from '../Buttons/NavigationButtons'

import styles from './HomeFactsSteps.module.scss'

import { selectHomeBeds } from 'src/store/selectors/home/answers'

const BEDS = 'beds'

const EnterBeds = ({ onBeds, onBack, defaultBeds }) => {
  const bedsCount = useSelector(selectHomeBeds)
  const bedsCountRef = useRef(null)

  const handleSubmit = (e, data) => {
    e.preventDefault()
    const updatedBeds = parseInt(data[BEDS])
    const isDirty = parseInt(bedsCount) !== updatedBeds

    onBeds(parseInt(data[BEDS]), isDirty)
  }

  return (
    <Form
      name='homeFactsBeds'
      className={styles.homeFactsStep}
      onSubmit={handleSubmit}
      fields={[BEDS]}
    >
      <Text align='center' size='s' color='heather' className={styles.headLine}>
        <FormattedMessage
          id='TYV.panels.bedrooms.headline'
          defaultMessage='QUICK CHECK:'
        />
      </Text>
      <Text align='center' size='xl' className={styles.title}>
        <FormattedMessage
          id='TYV.panels.bedrooms.title'
          defaultMessage='How many bedrooms do you have?'
        />
      </Text>
      <div className={styles.bedroomContent}>
        <FormField
          className={styles.incrementorInput}
          input={Incrementor}
          ref={bedsCountRef}
          value={bedsCount || defaultBeds}
          name={BEDS}
          min={1}
        >
          Bedrooms
        </FormField>
      </div>
      <NavigationButtons handleBack={() => onBack(null)} />
    </Form>
  )
}

export default EnterBeds
